import { GRAAL_API_URL } from "../../config";
import { graalApiAxiosInstance } from "../../middlewares/useApiAuthMiddleware";

// Agent de tarification (PER-2432 à PER-2435) : graal est la source de vérité
// de son avancée et de ses réglages ; le back-office ne parle jamais à l'agent.
// Depuis PER-2498, graal suit une demande compagnie par compagnie : les
// commandes et le verdict visent une compagnie (`compagnie`, slug du
// référentiel de graal) ; sans elle, graal prend sa compagnie par défaut.
const leadsAutoURI = `${GRAAL_API_URL}new-leads`;

// Corps ou paramètres d'une requête, avec la compagnie seulement quand elle est donnée.
const avecCompagnie = (compagnie, base = {}) => (compagnie ? { ...base, compagnie } : { ...base });

/**
 * Timeline de l'agent sur une demande : résumé (état, commande en cours,
 * interrupteurs, verdict), événements, et `compagnies[]` (le déroulé de chaque
 * compagnie, PER-2498). `compagnie` limite les événements rendus à celle-ci.
 */
export const getAgentTimeline = (leadUuid, compagnie) =>
  graalApiAxiosInstance.get(`${leadsAutoURI}/${leadUuid}/agent`, compagnie ? { params: { compagnie } } : undefined);

/**
 * Commande nominative à l'agent, chez une compagnie : { type: "lancer" | "regenerer" } ou
 * { type: "franchir", interrupteur: "creation_projet" | "envoi_prospect" }.
 * 409 avec un message quand elle n'a pas de sens dans l'état courant de cette compagnie.
 */
export const commanderAgent = (leadUuid, commande, compagnie) =>
  graalApiAxiosInstance.post(`${leadsAutoURI}/${leadUuid}/agent/commandes`, avecCompagnie(compagnie, commande));

/**
 * Verdict d'éligibilité redemandé à l'agent après correction d'une demande
 * écartée (PER-2449), chez une compagnie : 200 { compagnie, eligible, motif,
 * criteresIgnores, evalueLe } ; 409 si l'agent refuse (message), 503 s'il est
 * injoignable. L'agent remonte lui-même l'événement : la timeline se recharge ensuite.
 */
export const reevaluerEligibiliteAgent = (leadUuid, compagnie) =>
  graalApiAxiosInstance.post(`${leadsAutoURI}/${leadUuid}/agent/eligibilite`, avecCompagnie(compagnie));

/** Interrupteurs de l'agent pour une compagnie (paramètres). */
export const getAgentInterrupteurs = (compagnie = "assurali") =>
  graalApiAxiosInstance.get(`${leadsAutoURI}/agent/interrupteurs`, {
    params: { compagnie },
  });

/** Ouvre ou ferme un interrupteur ; l'auteur est tracé côté graal. */
export const setAgentInterrupteur = ({ compagnie, nom, ouvert }) =>
  graalApiAxiosInstance.put(`${leadsAutoURI}/agent/interrupteurs`, {
    compagnie,
    nom,
    ouvert,
  });
